import { useState, useEffect } from 'react'
import { getDepartmentsExpandAPI } from '../../services/departments'

function UseDepartmentsExpand(orgId, divisionId, factionId, departmentId) {
  const [data, setData] = useState([])
  useEffect(() => {
    const param = {
      orgId,
      dsId: divisionId,
      facId: factionId,
      searchs: departmentId
    }
    const getData = async () => {
      const resp = await getDepartmentsExpandAPI(param)
      if (!resp) return

      if (resp.status) {
        const newData =
          resp.result &&
          resp.result.map((d, i) => {
            return {
              value: d?.dm_id,
              label: `${d?.department_en} (${d?.department})`,
              data: d?.department_en
            }
          })

        setData(newData)
      }
    }
    if (orgId) {
      getData()
    }
  }, [orgId, factionId])

  return data
}

export default UseDepartmentsExpand
